import React, { useState } from "react";
import Header from "../components/promoCode/Header";
import PromoCodeTableOverview from "../components/promoCode/PromoCodeTableOverview";
import EditPromoCode from "../components/promoCode/EditPromoCode";
import AddNewPromoCode from "../components/promoCode/AddNewPromoCode";

const PromoCode = () => {
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [editPromoCode, setEditPromoCode] = useState(false);
  const [addPromoCode, setAddPromoCode] = useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleAddPromoCodeClick = () => {
    setIsTableVisible(false);
    setAddPromoCode(true);
  };

  const handleEditPromoCodeClick = (promoCode) => {
    setIsTableVisible(false);
    setEditPromoCode(true);
    setSelectedPromoCode(promoCode);
  };

  const handleBackToTable = () => {
    setIsTableVisible(true);
    setAddPromoCode(false);
    setEditPromoCode(false);
    setSelectedPromoCode(null);
  };

  return (
    <div className="px-4 py-4">
      {isTableVisible && (
        <>
          <Header onAddClick={handleAddPromoCodeClick} />
          <PromoCodeTableOverview
            onEditClick={handleEditPromoCodeClick}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        </>
      )}

      {editPromoCode && (
        <EditPromoCode
          retailer={selectedPromoCode}
          handleBackToTable={handleBackToTable}
        />
      )}
      {addPromoCode && (
        <AddNewPromoCode handleBackToTable={handleBackToTable} />
      )}
    </div>
  );
};

export default PromoCode;
